import { SchemaWidgetInstance } from "../SchemaWidgetClass";
import { postalAddressJson } from "./postalAddressJsonLd";

export const eventJson = (data: SchemaWidgetInstance, page: any) => {
  const start = data.get("date") || page?.get("date");
  const end = data.get("endDate") || page?.get("endDate");
  const eventType = data.get("eventType");
  const isVirtual = eventType === "VirtualLocation";
  const schemaType = data.get("eventSubtype") || "Event";

  const eventJsonLd = {
    "@context": "https://schema.org",
    "@type": schemaType,
    name: data.get("name") || page?.get("title") || null,
    description: data.get("description") || page?.get("description") || null,
    startDate: start?.toISOString(),
    endDate: end?.toISOString(),
    organizer: {
      "@type": "Organization",
      name: data.get("organizerName") || page?.get("organizerName") || null,
      url: data.get("url") || page?.get("organizerUrl") || null,
    },
    eventAttendanceMode: `https://schema.org/${
      isVirtual ? "Online" : "Offline"
    }EventAttendanceMode`,
    location: {
      "@type": isVirtual ? "VirtualLocation" : "Place",
      ...(isVirtual
        ? {
            url: data.get("locationUrl"),
          }
        : {
            address: postalAddressJson(data, page),
          }),
    },
  };

  return eventJsonLd;
};
